// extracted by mini-css-extract-plugin
export default {"clientDetailsContainer":"ClientDetails_clientDetailsContainer__UJdgK","contactDetails":"ClientDetails_contactDetails__lpiSN"};